// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yrbP","title":"styles_title__1F3bb"};